require('./payrollLoanUploadStatus.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const get = require('lodash/object/get');

class PayrollLoanUploadStatus extends React.Component {
    buildErrorMessageSection() {
        const { error, errorMessage } = this.props;

        if (!error) {
            return null;
        }

        return (
            <div className="payroll-loan-upload-status__error-message">
                <span>{errorMessage}</span>
            </div>
        );
    }

    render() {
        const {
            customFileDescription,
            error,
            file
        } = this.props;

        let icon;
        if (error) {
            icon = <i className="payroll-loan-upload-status__icon payroll-loan-upload-status__icon--error icon-error"></i>;
        } else if (file) {
            icon = <i className="payroll-loan-upload-status__icon payroll-loan-upload-status__icon-success"></i>;
        } else {
            icon = <i className="payroll-loan-upload-status__icon icon-subir"></i>;
        }

        const dropzoneClassNames = classNames('payroll-loan-upload-status__dropzone', {
            'payroll-loan-upload-status__dropzone--error': error
        });

        const dropzoneDescriptionClassNames = classNames('payroll-loan-upload-status__dropzone-description', {
            'payroll-loan-upload-status__dropzone-description--loaded': file,
            'payroll-loan-upload-status__dropzone-description--not-loaded': !file
        });

        const fileDescriptionClassNames = classNames('payroll-loan-upload-status__file-description', {
            'payroll-loan-upload-status__file-description--loaded': file,
            'payroll-loan-upload-status__file-description--not-loaded': !file
        });

        const errorMessageSection = this.buildErrorMessageSection();
        let fileName = customFileDescription;
        if (file) {
            fileName = get(file, 'name') || file.get('name');
        }

        return (
            <section className="payroll-loan-upload-status">
                <div className="payroll-loan-upload-status__container-title">
                    {customFileDescription}
                </div>
                <div className="row no-gutter">
                    <div className="col-xs-12">
                        <div className={dropzoneClassNames}>
                            <div className={dropzoneDescriptionClassNames}>
                                {icon}
                                <p className={fileDescriptionClassNames}>
                                    {fileName}
                                </p>
                            </div>
                        </div>
                        {errorMessageSection}
                    </div>
                </div>
            </section>
        );
    }
}

PayrollLoanUploadStatus.propTypes = {
    customFileDescription: PropTypes.string.isRequired,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    file: PropTypes.object,
    id: PropTypes.number
};

module.exports = PayrollLoanUploadStatus;
